import { createEdocSubscriptionEmail } from "@onair/services/e-document";
import { useMutation } from "@tanstack/react-query";

const useCreateEdocSubsciptionEmail = () => {
	return useMutation({
		mutationFn: createEdocSubscriptionEmail,
	});
};

export { useCreateEdocSubsciptionEmail };
